// Contacts — the saved name↔number list backing the SMS-compose
// autocomplete and the Contacts modal. internal/contacts.

import type { ApiClient } from "./client.js";
import type { ContactAddResponse, ContactRemoveResponse, ContactsListResponse } from "./types.js";

export function makeContactsApi(client: ApiClient) {
  return {
    /** List contacts; `q` filters by name or number (server-side prefix/substring). */
    list(q?: string) {
      return client.get<ContactsListResponse>("/v1/api/contacts", q ? { q } : undefined);
    },
    /** Add a contact. `number` is normalised + validated server-side; conflicts 409. */
    add(name: string, number: string) {
      return client.post<ContactAddResponse>("/v1/api/contacts", { name, number });
    },
    /** Remove a contact by id. */
    remove(id: number) {
      return client.delete<ContactRemoveResponse>(`/v1/api/contacts?id=${encodeURIComponent(id)}`);
    },
  };
}

export type ContactsApi = ReturnType<typeof makeContactsApi>;
